import React from 'react';

import { AddButton } from '../../../../components/Button';
import CommonDataGrid from '../../../../components/CommonDataGrid';
import { Column } from '../../../../components/CommonDataGrid/props';
import Loader from '../../../../components/Loader';
import Modal from '../../../../components/Model';
import EditImg from '../../../../images/SideBar/Edit';
import { formatDate, style, stylePriority } from '../../../../util/constant';
import EditTaskSheetIndex from '../../Backlog/Components/EditTasksheet/index';
import useTaskSheet from '../../Backlog/useTasksheet';

const TaskSheet: React.FC = () => {
  const {
    selectedTaskSheetId,
    showConfirmation,
    handleCancelStatusUp,
    updateScreen,
    handleEdit,
    handleSelectStatus,
    setSearch,
    setBackPage,
    backPage,
    loading,
    backLogData,
    backLogPage,
    handleBackLog,
    showModal,
    description,
    setDescription,
    handleModalSubmit,
    handleModalClose,
    adminComment,
  } = useTaskSheet();
  const backLogColumns: Column[] = [
    {
      field: "createdAt",
      renderCell: (params: any) => <p>{formatDate(params?.value)}</p>,
      headerName: "Date",
      width: 50,
      align: "center",
    },
    {
      field: "projectId",
      renderCell: (params: any) => <p>{params?.value?.name}</p>,
      headerName: "Project",
      width: 50,
      align: "center",
    },
    {
      field: "assignedTo",
      renderCell: (params: any) => <p>{params?.value?.name}</p>,
      headerName: "employee",
      width: 50,
      align: "center",
    },
    {
      field: "backLog",
      renderCell: (params: any) => <p className='text-red-600 font-bold'>{params?.value}</p>,
      headerName: "comment",
      width: 50,
      align: "center",
    },
    {
      field: "description",
      // renderCell: (params: any) => <p>{params?.value?.name}</p>,
      headerName: "Task",
      width: 50,
      align: "center",
    },
    {
      field: "Actions",
      renderCell: (params: any) => (
        <div className={style[params.row.status] || "bg-gray-200"}>
          <select
            defaultValue={params.row.status}
            onChange={(event) => handleSelectStatus(event, params.row._id)}
            className="appearance-none bg-transparent outline-none w-full cursor-pointer font-semibold"
          >
            <option value="todo">To Do</option>
            <option value="in progress">In Progress</option>
            <option value="query">Query</option>
            <option value="finished">Finished</option>
            <option value="backLog">Back Log</option>
          </select>
        </div>
      ),
      headerName: "Status",
      width: 50,
      align: "center",
    },
  ];
  return (
    <div>
      <div className="m-5 bg-white">
        {loading && <Loader />}
        <div>
          {selectedTaskSheetId ? (
            <EditTaskSheetIndex
              taskSheetId={selectedTaskSheetId}
              setMethod={() => updateScreen("edit")}
            />
          ) : (
            <>
                <div className="w-full">
                  <CommonDataGrid
                    tableName="Back Log"
                    rows={backLogData}
                    columns={backLogColumns}
                    getRowId={(row) => row._id}
                    showConfirmation={showConfirmation}
                    confirmationMessage="Are you sure you want to Status Update this TaskSheet?"
                    onCancelDelete={handleCancelStatusUp}
                    onConfirmDelete={() => {}}
                    loading={!backLogData}
                    onDateFilter={handleBackLog}
                    setSearchBar={setSearch}
                    setCurrentPage={setBackPage}
                    currentPage={backPage}
                    totalPages={backLogPage}
                    downloadCSVFilter={false}
                    mainStyle="w-full"
                    dayFilter={false}
                    searchFilter={false}
                    defaultDateNumber={"1"}
                  />
                </div>
            </>
          )}
        </div>
      </div>

      {showModal && (
        <Modal isOpen={showModal} onClose={handleModalClose}>
          <div className="p-4">
            <textarea
              className="w-full p-2 border rounded"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description..."
            />
            <div className="flex justify-end mt-4 space-x-2">
              <button
                className="px-4 py-2 text-gray-600 border rounded hover:bg-gray-100"
                onClick={handleModalClose}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
                onClick={handleModalSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default TaskSheet;
